const STORAGE_PREFIX = "landing_listing_query_";

function storageKey(scopeId: string): string {
  return `${STORAGE_PREFIX}${scopeId}`;
}

export function saveLandingListingQuery(
  scopeId: string,
  listingQuery: string
): void {
  if (!scopeId || !listingQuery.trim()) return;
  try {
    sessionStorage.setItem(storageKey(scopeId), listingQuery);
  } catch {
    // Ignore quota / private mode errors
  }
}

export function loadLandingListingQuery(scopeId: string): string {
  if (!scopeId) return "";
  try {
    return sessionStorage.getItem(storageKey(scopeId)) ?? "";
  } catch {
    return "";
  }
}
